// DS: i2.10
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ArrowRight: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M12.34 7.05a1 1 0 000 1.41l3.04 3.04H6.5a1 1 0 00-1 .88v.12a1 1 0 00.88 1h9.42l-3.46 3.45a1 1 0 001.42 1.41l4.95-4.95a1 1 0 000-1.41l-4.95-4.95a1 1 0 00-1.42 0z"
        clipRule="evenodd"
      />
    </svg>
  </IconWrap>
);
ArrowRight.displayName = 'ArrowRight';

export default ArrowRight;
